import { Input } from "@/components/ui/input";
import { useState } from "react";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { useFormContext } from "react-hook-form";
import { FormField, FormItem, FormMessage } from "@/components/ui/form";

type AgentInfoStepProps = {
  setStep: (step: number) => void;
};

export default function AgentInfoStep({ setStep }: AgentInfoStepProps) {
  const [focusedInput, setFocusedInput] = useState<string | null>(null);
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const handleFocus = (inputName: string) => {
    setFocusedInput(inputName);
  };

  const handleBlur = () => {
    setFocusedInput(null);
  };

  return (
    <>
      <div className="flex flex-col">
        <h2 className="text-5xl font-bold mb-20 text-white text-center">
          BASIC INFO
        </h2>

        <div className="space-y-8 mb-16 max-w-md mx-auto w-full">
          <FormField
            control={control}
            name="name"
            render={({ field }) => (
              <FormItem className="space-y-2">
                <Label
                  className={`block text-sm font-medium ${focusedInput === "name" ? "text-primary" : "text-gray-300"}`}
                >
                  NAME
                </Label>
                <Input
                  placeholder="Enter name"
                  type="text"
                  className={`w-full px-4 py-6 rounded border border-[#333333] text-white h-9 ${focusedInput === "name" ? "border-[#c8ff00]" : ""} ${errors.name ? "border-red-500" : ""}`}
                  onFocus={() => handleFocus("name")}
                  {...field}
                  onBlur={() => {
                    handleBlur();
                    field.onBlur();
                  }}
                />
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={control}
            name="bio"
            render={({ field }) => (
              <FormItem className="space-y-2">
                <Label
                  className={`block text-sm font-medium ${focusedInput === "bio" ? "text-primary" : "text-gray-300"}`}
                >
                  BIO
                </Label>
                <Textarea
                  placeholder="Write a bio"
                  className={`w-full px-4 py-4 rounded border border-[#333333] text-white min-h-[120px] resize-none ${errors.bio ? "border-red-500" : ""}`}
                  onFocus={() => handleFocus("bio")}
                  {...field}
                  onBlur={() => {
                    handleBlur();
                    field.onBlur();
                  }}
                />
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
      </div>
      <div className="max-w-md mx-auto w-full pb-12">
        <div className="flex flex-col sm:flex-row justify-between gap-4">
          <Button
            onClick={() => setStep(0)}
            variant="outline"
            className="w-full sm:min-w-[180px] md:min-w-[220px] py-2 sm:py-3 px-4 sm:px-6 min-h-[48px] text-center font-semibold text-base sm:text-lg"
          >
            BACK
          </Button>

          <Button
            onClick={() => setStep(2)}
            variant="default"
            className="w-full sm:min-w-[180px] md:min-w-[220px] py-2 sm:py-3 px-4 sm:px-6 min-h-[48px] text-center font-semibold text-base sm:text-lg"
          >
            NEXT
          </Button>
        </div>
      </div>
    </>
  );
}
